import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Button, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from 'reactstrap';
import Table from '../../../components/UI/Table/Table';
import Modal from '../../../components/UI/Modal/Modal';
import { toast } from 'react-toastify';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
// import { TABLE_COLUMNS } from './constants';
import { fetchCorrespondentList, enableCorrespondent, deleteCorrespondentEntity } from './action';

let that;
const TABLE_COLUMNS = [
    {
        Header: "Name",
        id: "correspondentEntityName",
        accessor: p => <p title={p.correspondentEntityName}>{p.correspondentEntityName}</p>
    },
    {
        Header: "State",
        id: "state",
        accessor: d => <div title={d.state}>{d.state}</div>
    },
    {
        Header: "City",
        id: "city",
        accessor: d => <div title={d.city}>{d.city}</div>
    },
    {
        Header: "GST No",
        id: "ETA",
        accessor: p => <div title={p.gstNum}>{p.gstNum}</div>,
    },
    {
        Header: "PAN No",
        id: "panNo",
        accessor: p => <div title={p.panNo}>{p.panNo}</div>,
        className: 'center'
    },
    {
        Header: "Users",
        id: "user",
        accessor: p => (p.casesPerUserMap) ? <div style={{ width: 50 + 'px', textAlign: 'center' }} title={Object.keys(p.casesPerUserMap).length + ' Users'}>{Object.keys(p.casesPerUserMap).length}</div> : <div>0</div>,
        className: 'center',
        width: 80
    },
    {
        Header: "Sections",
        id: "offerings",
        accessor: p => <div title={p.offerings.length + ' Sections'} style={{ width: 50 + 'px', textAlign: 'center' }}>{p.offerings.length}</div>,
        className: 'center'
    },
    {
        Header: "Action",
        id: "archived",
        accessor: p => (p.archived) ?
            <Button color="primary" onClick={() => that.handleEnable(p.id)}>Enable</Button>
            :
            <div>
                <Link id={p.id} to={`./../onboard/edit/${p.id}`} className="p-1"><i className="icon-edit p-2 border border-primary radius-5"></i></Link>
                <i className="icon-delete pointer text-primary p-2 border border-primary radius-5" onClick={() => that.handleDeleteCorrespondent(p.id)}></i>
            </div>

    }
]
class CorrespondentList extends Component {
    constructor() {
        super();
        this.state = {
            correspondentListData: [],
            tableColumns: TABLE_COLUMNS,
            loading: true
        }
        that = this;
    }
    componentDidMount() {
        setPageView('/Admin/Correspondent/list', document.location.href);
        this.props.fetchCorrespondentList();
    }
    componentDidUpdate(prevProps) {
        const { correspondentList, deleteCorrespondent, deleteCorrespondentFailure, enableCorrespondentSuccess, enableCorrespondentFailure } = this.props
        if (correspondentList !== prevProps.correspondentList) {
            this.setState({
                correspondentListData: correspondentList,
                loading: false
            })
        }
        if (deleteCorrespondent !== prevProps.deleteCorrespondent) {
            goolgeAnalyticsEvents('Admin', 'Delete Correspondent', 'Delete', '')
            this.props.fetchCorrespondentList();
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{deleteCorrespondent.data.message}
                </div>
            );
        }
        if (deleteCorrespondentFailure !== prevProps.deleteCorrespondentFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation"></i>&nbsp;{deleteCorrespondent.response.data.message}
                </div>
            );
        }
        if (enableCorrespondentSuccess !== prevProps.enableCorrespondentSuccess) {
            goolgeAnalyticsEvents('Admin', 'Enable Archived Correspondent', 'Enable correspondent', '')
            this.props.fetchCorrespondentList();
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Enbaled Successfully
                </div>
            );
        }
        if (enableCorrespondentFailure !== prevProps.enableCorrespondentFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation"></i>&nbsp;{(enableCorrespondentFailure.response && enableCorrespondentFailure.response.data) ? enableCorrespondentFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
    }
    handleRedirect = () => {
        this.props.fetchCorrespondentList();
        this.handleToggle();
    }
    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }
    handleEnable = (id) => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: <div>
                <ModalHeader>Confirm</ModalHeader>
                <ModalBody>
                    <span className="text-danger">&nbsp;&nbsp;Are you sure you want to enable this entity </span>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.handleToggle}>Cancel</Button>
                    <Button color="primary" onClick={() => this.handleEnableConfirm(id)}>Ok</Button>
                </ModalFooter>
            </div>
        }))
    }
    handleEnableConfirm = (id) => {
        this.props.enableCorrespondent(id);
        this.handleToggle();
    }
    handleDeleteCorrespondent = (id) => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: <div>
                <ModalHeader>Confirm</ModalHeader>
                <ModalBody>
                    <span className="text-danger">&nbsp;&nbsp;Are you sure you want to delete</span>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.handleToggle}>Cancel</Button>
                    <Button color="primary" onClick={() => this.handleDeleteConfirm(id)}>Ok</Button>
                </ModalFooter>
            </div>
        }))
    }
    handleDeleteConfirm = (id) => {
        this.props.deleteCorrespondentEntity(id);
        this.handleToggle();
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">List of all Correspondents</h4>
                </div>
                <Card>
                    <CardBody>
                        <Table
                            data={this.state.correspondentListData}//{this.props.searchData}
                            columns={this.state.tableColumns}
                            /* defaultSorted={[
                              {
                                id: "ETA",
                                desc: true
                              }
                            ]} */
                            loading={this.state.loading}
                            defaultPageSize={10}
                            className=""
                        />
                    </CardBody>
                </Card>
                <Modal show={this.state.showModal} className='Modal' >
                    {this.state.body}
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    correspondentList: state.correspondentAdminList.correspondentList,
    deleteCorrespondent: state.correspondentAdminList.deleteCorrespondentSuccess,
    deleteCorrespondentFailure: state.correspondentAdminList.deleteCorrespondentFailure,
    enableCorrespondentSuccess: state.correspondentAdminList.enableCorrespondentSuccess,
    enableCorrespondentFailure: state.correspondentAdminList.enableCorrespondentFailure
})

const mapDispatchToProps = (dispatch) => ({
    fetchCorrespondentList: () => { dispatch(fetchCorrespondentList()) },
    enableCorrespondent: (id) => { dispatch(enableCorrespondent(id)) },
    deleteCorrespondentEntity: (id) => { dispatch(deleteCorrespondentEntity(id)) }
});
export default connect(mapStateToProps, mapDispatchToProps)(CorrespondentList);
